import { render, staticRenderFns } from "./InsightsContent.vue?vue&type=template&id=f9c0de80"
import script from "./InsightsContent.vue?vue&type=script&lang=js"
export * from "./InsightsContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports